module.exports = __webpack_public_path__ + "static/media/11.62742201.png";